import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from 'reactstrap';

import { SectionTitle } from '../../../../components/text';
import { isNumber } from '../../../../utils/math';
import { useTexts } from './hooks/useTexts';
import { StudyPlansLoader } from './parts/StudyPlansLoader';
import { StudyPlansTable } from './parts/StudyPlansTable';

export function StudentStudyPlans() {
  const texts = useTexts();
  const { studentId } = useParams<{ studentId: string }>();
  const studentIdInt = useMemo(() => {
    if (isNumber(studentId)) {
      return Number(studentId);
    }
    return null;
  }, [studentId]);
  if (!studentIdInt) {
    throw new Error('Invalid studentId');
  }

  return (
    <StudyPlansLoader studentId={studentIdInt}>
      {({ data }) => (
        <>
          <Col className="my-4">
            <Row>
              <SectionTitle text={texts.sectionTitle} />
            </Row>
          </Col>
          <StudyPlansTable studyPlans={data.studyPlans} />
        </>
      )}
    </StudyPlansLoader>
  );
}
